import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_2 = { class: "flex items-center ml-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "pb-2 pl-2 text-lg" }, " ⌄", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")
  const _component_router_link = _resolveComponent("router-link")
  const _component_profile_photo_component = _resolveComponent("profile-photo-component")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.isLoggedIn || !_ctx.isEmailVerified)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "flex items-center ml-auto text-2xl font-semibold",
          to: { name: _ctx.Routes.LOGIN },
          "data-testid": "login-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_button_component, { class: "flex items-center p-4 py-2 text-sm rounded focus:outline-none whitespace-nowrap" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: { name: _ctx.Routes.PROFILE },
          class: "flex items-center p-4 py-2 text-sm rounded cursor-pointer focus:outline-none whitespace-nowrap",
          "data-testid": "profile-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_profile_photo_component, {
              class: "w-10 h-10",
              user: _ctx.currentUser
            }, null, 8, ["user"]),
            _createVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.currentUser.displayName) + " ", 1),
              _hoisted_3
            ])
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}